export default __webpack_public_path__ + "static/media/Arrow Right.e262efe3.svg";